import React from 'react';
import { CampaignShimmeredDetailsList } from '@bingads-webui-grid/campaign-details-list';
import { SelectionMode, Panel, PanelType } from '@fluentui/react';

import { iconButtonStyles, contentStyles } from './report-grid-modal-style';

export const SidePanelReportGrid = (props) => {
  const {
    isSearchInsightReportOpen, hideSidePanel, i18n, items, columns, onSort, sortedColumn, pager, onPageChange, onPageSizeChange, isLoadedAndNoDataFound, searchCategoryTitle
  } = props;

  function renderSidePanelReportGrid() {
    return (
      <div className={`${contentStyles.noDataplaceHolder} collapsed-rows-report-details-no-data`}>
        {i18n.getString(_TL_('No Search Term match selected criteria.'))}
      </div>
    );
  }

  return (
    <Panel
      isOpen={isSearchInsightReportOpen}
      onDismiss={hideSidePanel}
    // You MUST provide this prop! Otherwise screen readers will just say "button" with no label.
      closeButtonAriaLabel="Close"
      styles={iconButtonStyles}
      type={PanelType.medium}
    >
      <div className={contentStyles.body}>

        <div style={{
          fontSize: '20px',
          fontWeight: 600,
          height: '50px',
        }}
        >
          {i18n.getString(_TL_('Search Terms of {{searchCategoryTitle}}'), { searchCategoryTitle })}
        </div>
        <CampaignShimmeredDetailsList
          stickyHeader
          items={items || []}
          columns={columns.filter(column => column.key !== 'SearchCategory')}
          selectionMode={SelectionMode.none}
          enableShimmer={!items}
          onSort={column => onSort(column)}
          sortedColumn={sortedColumn}
          freezingColumnCount={1}
          pager={{
            ...pager,
            onPageChange,
            onPageSizeChange,
          }}
          isSortedDescendingByDefault={false}
          isGridScrollable
        />
      </div>
      {isLoadedAndNoDataFound && renderSidePanelReportGrid()}
    </Panel>
  );
};
